import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SendIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SendIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M3 13.8771C3 13.3587 3.41407 12.9385 3.92485 12.9385H7.62426C8.13504 12.9385 8.54911 12.5183 8.54911 11.9999L8.54911 11.9999C8.54911 11.4816 8.13504 11.0613 7.62426 11.0613H3.92485C3.41407 11.0613 3 10.6411 3 10.1228V2.46929C3 2.21011 3.20704 2 3.46243 2C3.54034 2 3.61701 2.01998 3.68528 2.05809L20.7603 11.5887C20.9841 11.7137 21.0658 11.999 20.9427 12.2261C20.9004 12.3041 20.8371 12.3683 20.7603 12.4112L3.68528 21.9418C3.4615 22.0667 3.18032 21.9839 3.05724 21.7568C3.01969 21.6875 3 21.6097 3 21.5306V13.8771Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SendIcon;
